import {
  VITE_REACT_APP_AUTH0_AUDIENCE,
  VITE_REACT_APP_AUTH0_CLIENT_ID,
  VITE_REACT_APP_AUTH0_DOMAIN,
  VITE_REACT_APP_AUTHENTIK_CLIENT_ID,
  VITE_REACT_APP_AUTHENTIK_DOMAIN,
} from "../../constants/variables";
import { UserManagerSettings } from "oidc-client-ts";
import { CookieStorage } from "../../utils/storage/CookieStorage";
import { AuthRoutes } from "../AuthRoutes";
import { OAuth, OAuthOptions } from "./OAuth";
import { mobileHostSession } from "./host-session";

const storage = new CookieStorage();
const auth0Options: OAuthOptions = {
  audience: VITE_REACT_APP_AUTH0_AUDIENCE || "",
  scope: "openid offline_access profile email",
  domain: VITE_REACT_APP_AUTH0_DOMAIN || "",
  clientId: VITE_REACT_APP_AUTH0_CLIENT_ID || "",
  redirectUri: `${window.location.origin}${AuthRoutes.BASEPATH}${AuthRoutes.SOCIAL_REDIRECT}`,
};
const akOptions: UserManagerSettings = {
  authority:
    `https://${VITE_REACT_APP_AUTHENTIK_DOMAIN}/application/o/mela` || "",
  scope: "openid offline_access email mela_profile",
  client_id: VITE_REACT_APP_AUTHENTIK_CLIENT_ID || "",
  redirect_uri: `${window.location.origin}${AuthRoutes.BASEPATH}${AuthRoutes.SOCIAL_REDIRECT}?connection=entra`,
  // not yet supported by authentik
  // post_logout_redirect_uri: "http://localhost:3000/auth",
};

const oAuthClient = new OAuth(
  storage,
  auth0Options,
  akOptions,
  mobileHostSession,
);
export default oAuthClient;
